export const GET_ITEMS = "GET_ITEMS";
export const SET_SORT = "SET_SORT";
export const SET_CATEGORY = "SET_CATEGORY";
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const ADD_QUANTITY = "ADD_QUANTITY";
export const SUB_QUANTITY = "SUB_QUANTITY";
export const CLEAR_CART = "CLEAR_CART";
